import { FlexLanding } from "@components/flex/FlexLanding";
import { Partner, getPartner, partnerSlugs } from "@/lib/partners";
import { FLEX } from "@/lib/site";
import { createLocalizedSlugStaticPaths } from "@services/localized-static-paths";
import { GetStaticPaths, GetStaticProps } from "next";

const PartnerFlexPage = ({ partner }: { partner: Partner }) => (
  <FlexLanding partner={partner} />
);

export const getStaticPaths: GetStaticPaths = async () => {
  const { paths, fallback } = createLocalizedSlugStaticPaths(partnerSlugs);
  return {
    fallback,
    paths: paths.map(({ locale, params }) => ({
      locale,
      params: { partner: params.slug },
    })),
  };
};

export const getStaticProps: GetStaticProps = async (context) => {
  const partner = getPartner(context.params?.partner as string);
  // The paths are always listed; until live, every one of them is a 404.
  if (!FLEX.live || !partner) return { notFound: true };
  return { props: { partner } };
};

export default PartnerFlexPage;
